(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["popup"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const popupOverlay = document.getElementById('popupOverlay');
  
  // Exit early if popup doesn't exist (not on homepage)
  if (!popupOverlay) return;
  
  const closePopupBtn = document.getElementById('closePopupBtn');
  const discountForm = document.getElementById('discountForm');
  const copyBtn = document.getElementById('copyBtn');
  
  // KEY FIX: Check if user has closed popup in THIS SESSION
  // Uses sessionStorage - resets when browser tab closes or page refreshes
  const POPUP_CLOSED_KEY = 'smartixPopupClosed';
  const hasClosedPopup = sessionStorage.getItem(POPUP_CLOSED_KEY);
  
  // Check if device is DESKTOP ONLY (768px and above)
  const isDesktop = window.innerWidth > 768;
  
  // Only show popup if user hasn't closed it AND device is desktop
  if (!hasClosedPopup && isDesktop) {
    popupOverlay.classList.add('show');
  } else {
    // Hide popup if already closed OR on mobile
    popupOverlay.style.display = 'none';
  }
  
  // Close popup function
  function closePopup() {
    popupOverlay.classList.remove('show');
    // Set sessionStorage flag - resets when tab closes or new session starts
    sessionStorage.setItem(POPUP_CLOSED_KEY, 'true');
  }
  
  // Close button click
  closePopupBtn.addEventListener('click', function(e) {
    e.preventDefault();
    closePopup();
  });
  
  // Close when clicking overlay background
  popupOverlay.addEventListener('click', function(e) {
    if (e.target === popupOverlay) {
      closePopup();
    }
  });
  
  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closePopup();
    }
  });
  
  // Form submission
  if (discountForm) {
    discountForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const email = document.getElementById('popupEmail').value;
      const agreed = document.getElementById('popupAgree').checked;
      
      if (email && agreed) {
        alert('Thank you! Your 10% discount code has been sent to: ' + email);
        closePopup();
        discountForm.reset();
      }
    });
  }
  
  // Copy code functionality
  if (copyBtn) {
    copyBtn.addEventListener('click', function(e) {
      e.preventDefault();
      const code = 'WELCOME10';
      navigator.clipboard.writeText(code).then(function() {
        const copyTextEl = document.getElementById('copyText');
        copyTextEl.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px;flex-shrink:0" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg> COPIED!';
        setTimeout(function() {
          copyTextEl.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px;flex-shrink:0" aria-hidden="true"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg> TAP TO COPY';
        }, 2000);
      });
    });
  }
  
  // Make functions globally available for admin/testing purposes
  window.openDiscountPopup = function() {
    if (popupOverlay) {
      popupOverlay.style.display = 'flex';
      popupOverlay.classList.add('show');
    }
  };
  
  window.closeDiscountPopup = closePopup;
  
  // ADMIN FUNCTION: Clear sessionStorage to reset popup (for testing)
  // Note: sessionStorage automatically clears when tab closes or new session starts
  window.resetPopupForTesting = function() {
    sessionStorage.removeItem(POPUP_CLOSED_KEY);
    console.log('Popup sessionStorage cleared. Refresh page to see popup again.');
  };
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stitch-email-section"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const popupOverlay = document.getElementById('popupOverlay');
  const closePopupBtn = document.getElementById('closePopupBtn');
  const discountForm = document.getElementById('discountForm');
  const copyBtn = document.getElementById('copyBtn');
  
  if (!popupOverlay) return;
  
  // Ensure popup shows on load
  popupOverlay.classList.add('show');
  
  // Close popup function
  function closePopup() {
    popupOverlay.classList.remove('show');
  }
  
  // Close button click
  closePopupBtn.addEventListener('click', function(e) {
    e.preventDefault();
    closePopup();
  });
  
  // Close when clicking overlay background
  popupOverlay.addEventListener('click', function(e) {
    if (e.target === popupOverlay) {
      closePopup();
    }
  });
  
  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closePopup();
    }
  });
  
  // Form submission
  if (discountForm) {
    discountForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const email = document.getElementById('popupEmail').value;
      const agreed = document.getElementById('popupAgree').checked;
      
      if (email && agreed) {
        alert('Thank you! Your 10% discount code has been sent to: ' + email);
        closePopup();
        discountForm.reset();
      }
    });
  }
  
  // Copy code functionality
  if (copyBtn) {
    copyBtn.addEventListener('click', function(e) {
      e.preventDefault();
      const code = 'WELCOME10';
      navigator.clipboard.writeText(code).then(function() {
        const copyTextEl = document.getElementById('copyText');
        copyTextEl.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px;flex-shrink:0" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg> COPIED!';
        setTimeout(function() {
          copyTextEl.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px;flex-shrink:0" aria-hidden="true"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg> TAP TO COPY';
        }, 2000);
      });
    });
  }
  
  // Make functions globally available
  window.openDiscountPopup = function() {
    if (popupOverlay) popupOverlay.classList.add('show');
  };
  
  window.closeDiscountPopup = closePopup;
});

  } catch(e) { console.error(e); }
})();
})();
